import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";
import { siteInfo } from "@/mocks/siteInfo";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="inline-block">
              <span
                className="text-xl font-bold text-foreground-950"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                佐佐木希
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              日本顶级女艺人、模特与演员的官方粉丝资讯站，汇聚最新写真、影视作品、时尚造型及粉丝应援资讯。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about#reputation"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  口碑评价
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap"
                >
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">关注我们</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              获取佐佐木希最新动态与独家内容，请关注我们的社交媒体账号。
            </p>
            <div className="flex items-center gap-3 mt-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="Instagram"
                rel="nofollow"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="Twitter"
                rel="nofollow"
              >
                <i className="ri-twitter-x-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors"
                aria-label="YouTube"
                rel="nofollow"
              >
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All rights reserved.
          </p>
          <p className="text-xs text-foreground-500">
            <strong>免责声明：</strong>本站为非官方粉丝资讯站，所有内容仅供粉丝交流使用。
          </p>
        </div>
      </div>
    </footer>
  );
}